import { render } from "./HeroiconsOutlineDeviceTablet.vue?vue&type=template&id=3ba55ee0"
const script = {}

import exportComponent from "D:\\php-projects\\vemto apps\\tasky\\tasky_api_nova2_v9\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineDeviceTablet.vue"]])

export default __exports__